import { Component, forwardRef, Input, OnInit } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms'
import { Field } from '../../models/field'
import { Catalogue, CatalogueEntry } from '../../../../models/catalogue'
import { CatalogueService } from '../../../../services/catalogue.service'
import { map, switchMap, tap } from 'rxjs/operators'

@Component({
  selector: 'jml-lib-icon-control',
  templateUrl: './icon-control.component.html',
  styleUrls: ['./icon-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IconControlComponent),
      multi: true
    }
  ]
})
export class IconControlComponent implements OnInit, ControlValueAccessor {
  @Input() field: Field

  options = []
  onTouched = (id: number) => {}
  onChange = (id: number) => {}
  selectedId: number
  optionsLoaded = false

  constructor(private catalogueService: CatalogueService) {}

  writeValue(obj: any): void {
    this.selectedId = obj?.id ? obj.id : obj
    if (this.selectedId) {
      this.options?.forEach((e) => (e.active = e.id === this.selectedId))
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn
  }

  ngOnInit(): void {
    let entryCount = 0
    this.catalogueService
      .getCatalogue(this.field.defaultCatalogue)
      .pipe(
        tap((catalogue: Catalogue) => (entryCount = catalogue.values.length)),
        switchMap((catalogue: Catalogue) => catalogue.values),
        map((entry: CatalogueEntry) => {
          return {
            id: entry.id,
            name: entry.name,
            icon: entry.icon,
            color: entry.color,
            active: false
          }
        })
      )
      .subscribe((entry) => {
        this.options.push(entry)

        if (this.options.length == entryCount) {
          this.optionsLoaded = true
          this.options.forEach((e) => (e.active = e.id === this.selectedId))
        }
      })
  }

  onIconSelected(entry) {
    this.onTouched(entry.id)
    this.onChange(entry.id)
    this.options.forEach((e) => (e.active = entry === e))
  }
}
